import { useQuery } from "@tanstack/react-query";
import { getDeploymentTemplate } from "../../services/pdmApi.service";

export function useDeploymentTemplateDetails(
  templateId: string | null,
  open: boolean,
) {
  return useQuery({
    queryKey: ["deploymentTemplate", templateId],
    queryFn: () => getDeploymentTemplate(templateId as string),
    enabled: open && Boolean(templateId),
  });
}
